export const AdminBoardFieldController = {
    store(): void {},
    reorder(): void {},
    update(): void {},
    destroy(): void {},
};
